import FailedPayouts from 'Components/Payouts/FailedPayouts/FailedPayouts';
import { LpBox } from 'Constants/styles';

type Props = {
  merchantId: string;
};

const MerchantFailedPayouts = ({ merchantId }: Props) => {
  return (
    <LpBox>
      <FailedPayouts merchantId={merchantId} />
    </LpBox>
  );
};

export default MerchantFailedPayouts;
